__turbopack_context__.v({
  "homepageSlice": "HomepageSliceZone-module-scss-module__l2PQyW__homepageSlice",
});
